// Routes reachable without a session. The OAuth callbacks must stay public or
// the route guard blocks the code exchange. Single source of truth for both
// `protectedRoutes` (zudoku.config.tsx) and the AuthGate slot.
export const PUBLIC_ROUTES = ["/logged-out", "/oauth/*"] as const;

export const isPublicRoute = (pathname: string) =>
  PUBLIC_ROUTES.some((route) =>
    route.endsWith("/*")
      ? pathname.startsWith(route.slice(0, -1))
      : pathname === route,
  );
